module.exports = __webpack_public_path__ + "img/casino-wm.edc0aeb7.jpg";